<template lang="pug">
  .main
    h3(style="margin-bottom: 30px; text-align: center") Результаты определения рисков
    table.simpletable
      thead
        th Нозологическая группа
        th Риск не определен
        th Низкий
        th Умеренный
        th Высокий
        th Очень высокий
      tr(v-for="row in data.table.body" :key="row[0]")
        td(v-for="(cell, index) in row" :key="index" :style="{ 'text-align': index > 0 ? 'right' : 'left' }") {{cell}}
</template>
<script>
import axios from 'axios'
export default {
  props: ['data'],
  data () {
    return {
      groups: []
    }
  }
}
</script>
<style lang="sass" scoped>
.simpletable
  margin-bottom: 40px
  border-collapse: collapse
.simpletable td,
.simpletable th
  border: 1px solid #ccc
  padding: 10px
  vertical-align: middle
.simpletable thead th
  font-weight: bold
  text-align: center
table
  margin: auto
thead
  background-color: #074d59
th
  color: white
h3
  font-size: 25px
  font-weight: normal
  margin-bottom: 20px
  text-align: center
</style>
